import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { components } from 'react-select';
import { ReactComponent as BreadCrumbsdor }  from '../../../../myfin_v2/assets/icons/breadCrumbsDot.svg'
import { ReactComponent as PervBtnIcon }  from '../../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as CloseSideModel } from "../../../../myfin_v2/assets/icons/closeSideModel.svg";
import { ReactComponent as AccLoansIcon }  from '../../../../myfin_v2/assets/icons/AccLoans.svg'
import {ReactComponent as CalenderIcon} from "../../../assets/icons/calenderIcon.svg"
import {ReactComponent as CustModeLCloseIcon} from "../../../assets/icons/custModeLCloseIcon.svg"
import {ReactComponent as PrimaryPlusIcon} from "../../../assets/icons/plusprimary.svg"
import {ReactComponent as EditIcon} from "../../../assets/icons/edit.svg"
import {ReactComponent as WhitePlusIcon} from "../../../assets/icons/whitePlus.svg"

import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Breadcrumb from "../../../components/Breadcrumb";
import CompanyEditSideMenu from "../CompanyEditSideMenu"

import baseCss from "../../../css/dataBases.module.css"
import sidemenucss from "../../../css/sidemenu.module.css"
import commoncss from "../../../css/common.module.css";

import { Padding } from '@mui/icons-material';
import { Transaction } from '@sentry/tracing';

import { getAllCompanyRegisterDatabase, companyLoans, addToCompanyRegisterDatabase, updateCompanyRegisterDatabase, deleteCompanyRegisterDatabase, 
            getAllCompanyRegisterDatabaseReceivable, getAllCompanyReceivables, addToCompanyRegisterDatabaseRecev, updateCompanyRegisterDatabaseRecev, deleteCompanyRegisterDatabaseRecev } from "../../../../Bookclosure/Services/ApiHandler"

import Modal from "../../../elements/Modal";
import modalcss from "../../../css/modal.module.css";
import { Button } from "../../../elements/Button";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import buttoncss from "../../../css/button.module.css";

const DataBase = () => {

    const { companyId } = useParams();
    const [companyID, setCompanyID] = useState(companyId);  // company ID
    
    const [tab, settab] = useState(2)
    const [activeTab, setActiveTab] = useState('loan');
    const [createOrUpdate, setCreateOrUpdate] = useState('C');  // Example state for create or update
    
    const [loanDatabaseList, setloanDatabaseList] = useState([])
    const [receivableDatabaseList, setreceivableDatabaseList] = useState([])
    
    const [companiesLoansList, setcompaniesLoansList] = useState([])
    const [companiesReceiablesList, setcompaniesReceiablesList] = useState([])

    const [companyDataList, setCompanyDataList] = useState([])
    // const [companyDataListreceivables, setcompanyDataListreceivables] = useState([])
    const [userSelectedDataList, setuserSelectedDataList] = useState([])
    const [selectedReceivableList, setselectedReceivableList] = useState([])
    
    const [dataBaseType, setdataBaseType] = useState()
    const [fromDate, setfromDate] = useState()
    const [todate, settodate] = useState()
    const [asOnDate, setasOnDate] = useState()
    const [createModel, setcreateModel] = useState(false);
    const [updateOrCreateFlow, setupdateOrCreateFlow] = useState()
    const [updateDataBaseId, setupdateDataBaseId] = useState()

    
    useEffect(() => {
        pulllDataBaseLst();
        pulllDataBaseReceLst();
        pulllCompanyLoansLst();
    },
    [])

    const pulllDataBaseLst = () => {
        getAllCompanyRegisterDatabase(companyID).then(res => {
            setloanDatabaseList(res.data.loanDatabaseList)
        })
    }

    const pulllDataBaseReceLst = () => {
        getAllCompanyRegisterDatabaseReceivable(companyID).then(res => {
            setreceivableDatabaseList(res.data.receivableDatabaseList)
        })
    }

    

    const pulllCompanyLoansLst = () => {
        companyLoans(companyID).then(res => {
            let loansDt = res.data.loans

            const loanOptions = loansDt.map(loan => ({
                label: loan.name,
                value: loan._id
            }));

            setcompaniesLoansList(loanOptions)
            setCompanyDataList(loanOptions)
        })

        getAllCompanyReceivables(companyID).then(res => {
            let receivableDt = res.data.receivables

            const receOptions = receivableDt.map(loan => ({
                label: loan.name,
                value: loan._id
            }));

            setcompaniesReceiablesList(receOptions)
            setCompanyDataList(receOptions)
        })
    }

    const handleSelect = (selectedOption) => {

        // if(activeTab === 'loan'){
            if (!selectedOption) return;
                setuserSelectedDataList([...userSelectedDataList, selectedOption]);
                setCompanyDataList(companyDataList.filter(opt => opt.value !== selectedOption.value));
        // }
        // else if(activeTab === 'receivable'){
        //     if (!selectedOption) return;
        //         setselectedReceivableList([...selectedReceivableList, selectedOption]);
        //         setCompanyDataList(companyDataList.filter(opt => opt.value !== selectedOption.value));
        // }

    };

    const handleRemove = (optionToRemove) => {
        setuserSelectedDataList(userSelectedDataList.filter(opt => opt.value !== optionToRemove.value));
        setCompanyDataList([...companyDataList, optionToRemove]);
    };
    
    const sendDataToApi = (DataBaseType, requestMethod) => {
        
        const formatDate = (dateStr) => {
            const date = new Date(dateStr);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };


        if(requestMethod === 'create'){

            if(DataBaseType === 'loan'){
                
                const selectedLoanValues = userSelectedDataList.map(item => item.value);
    
                const finalObj = {
                    "companyID": companyID,              // Required - MongoDB ObjectId of the company
                    "type": DataBaseType,                // Required - Only allowed value is "loans"
                    "fromDate": formatDate(fromDate),    // Required - In DD-MM-YYYY format
                    "toDate": formatDate(todate),        // Required - Must be after fromDate (DD-MM-YYYY format)
                    "registerIDs": selectedLoanValues    // Required - Array of valid MongoDB ObjectIds of the registers
                }
    
                addToCompanyRegisterDatabase(finalObj).then(res => {
                    
                    pulllDataBaseLst();
                    toast.success('Added to database successfully');
                    setcreateModel(false)
    
                })

            }

            else if(DataBaseType === 'receivable'){

                const selectedReceValues = userSelectedDataList.map(item => item.value);
    
                const finalObj = {
                    "companyID": companyID,              // Required - MongoDB ObjectId of the company
                    "type": DataBaseType,                // Required - Only allowed value is "loans"
                    "asOnDate": formatDate(asOnDate),    // Required - In DD-MM-YYYY format
                    "registerIDs": selectedReceValues    // Required - Array of valid MongoDB ObjectIds of the registers
                }
    
                addToCompanyRegisterDatabaseRecev(finalObj).then(res => {
                    
                    pulllDataBaseReceLst();
                    toast.success('Added to database successfully');
                    setcreateModel(false)
    
                })

            }

        }

        else if(requestMethod === 'update'){

            if(DataBaseType === 'loan'){

                const selectedLoanValues = userSelectedDataList.map(item => item.value);

                const finalObj = {
                    "companyID": companyID,                  // Required - MongoDB ObjectId of the company
                    "type": DataBaseType,                    // Required - Only allowed value is "loans"
                    "fromDate": formatDate(fromDate),        // Required - In DD-MM-YYYY format
                    "toDate": formatDate(todate),            // Required - Must be after fromDate (DD-MM-YYYY format)
                    "registerIDs": selectedLoanValues,       // Required - Array of valid MongoDB ObjectIds of the registers
                }
    
                updateCompanyRegisterDatabase(updateDataBaseId,finalObj).then(res => {
                    
                    pulllDataBaseLst();
                    toast.success('Database updated successfully');
                    setcreateModel(false)
    
                })

            }

            else if(DataBaseType === 'receivable'){

                const selectedReceValues = userSelectedDataList.map(item => item.value);
    
                const finalObj = {
                    "companyID": companyID,              // Required - MongoDB ObjectId of the company
                    "type": DataBaseType,                // Required - Only allowed value is "loans"
                    "asOnDate": formatDate(asOnDate),    // Required - In DD-MM-YYYY format
                    "registerIDs": selectedReceValues    // Required - Array of valid MongoDB ObjectIds of the registers
                }
    
                updateCompanyRegisterDatabaseRecev(updateDataBaseId,finalObj).then(res => {
                    
                    pulllDataBaseReceLst();
                    toast.success('Added to database successfully');
                    setcreateModel(false)
    
                })

            }

        }

        else if(requestMethod === 'delete'){
            if(DataBaseType === 'loan'){
                deleteCompanyRegisterDatabase(updateDataBaseId).then(res => {
                    
                    pulllDataBaseLst();
                    toast.success('Database deleted successfully');
                    setcreateModel(false)
    
                })
            }

            if(DataBaseType === 'receivable'){
                deleteCompanyRegisterDatabaseRecev(updateDataBaseId).then(res => {
                    
                    pulllDataBaseReceLst();
                    toast.success('Database deleted successfully');
                    setcreateModel(false)
    
                })
            }
        }

    }


    const priFillDataInModel = (DataBaseType, dataBaseId) => {

        setupdateDataBaseId(dataBaseId)

        setupdateOrCreateFlow('update')

        if(DataBaseType === 'loan'){
            
            setdataBaseType('loan')
            setcreateModel(true)
            
            const foundEntry = loanDatabaseList.find(entry => entry._id === dataBaseId);

            setfromDate(new Date(foundEntry.fromDate));
            settodate(new Date(foundEntry.toDate));

            // Extract register IDs from foundEntry
            const registerIdsToRemove = foundEntry?.registers.map(r => r._id);

            // Filter from companiesLoansList
            const updatedList = companiesLoansList.filter(
                item => !registerIdsToRemove.includes(item.value)
            );

            const loanOptions = foundEntry?.registers.map(loan => ({
                label: loan.name,
                value: loan._id
            }));

            setuserSelectedDataList(loanOptions)
            
            setCompanyDataList(updatedList)

        }
        else if(DataBaseType === 'receivable'){

            setdataBaseType('receivable')
            setcreateModel(true)
            
            const foundEntry = receivableDatabaseList.find(entry => entry._id === dataBaseId);

            setasOnDate(new Date(foundEntry.asOnDate));

            // Extract register IDs from foundEntry
            const registerIdsToRemove = foundEntry?.registers.map(r => r._id);

            // Filter from companiesReceiablesList
            const updatedList = companiesReceiablesList.filter(
                item => !registerIdsToRemove.includes(item.value)
            );

            const receOptions = foundEntry?.registers.map(rece => ({
                label: rece.name,
                value: rece._id
            }));

            setuserSelectedDataList(receOptions)
            
            setCompanyDataList(updatedList)

        }

    }

    const openModel = () =>{
        setupdateOrCreateFlow('create')
        if(activeTab === 'loan'){
            setdataBaseType('loan')
            setCompanyDataList(companiesLoansList)
        }
        if(activeTab === 'receivable'){
            setdataBaseType('receivable')
            console.log('companiesReceiablesList :: ',companiesReceiablesList);
            setCompanyDataList(companiesReceiablesList)
        }
        setasOnDate()
        setfromDate()
        settodate()
        setuserSelectedDataList([])
        setcreateModel(true)
    }

    const [companyName, setcompanyName] = useState('');  // company name
    const [editLabel, setEditLabel] = useState(false); 

    return (
        <div className={`${baseCss.subContainer}`}>
            <CompanyEditSideMenu 
                companyID={companyID}
                activeTab={'Database'}
                companyDataCheck={true}
                setcompanyName={setcompanyName}
            />
            
            <div className={baseCss.subContainer__}>

                <DataBaseHeader
                    openModel={openModel}
                    tab={tab}
                    settab={settab}
                    companyID={companyID}
                    setcreateModel={setcreateModel}
                    companyName={companyName}
                    setEditLabel={setEditLabel}
                />

                <MulitTabsContainer 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab}
                    tab={tab}
                    settab={settab}
                    createOrUpdate={createOrUpdate} 
                    setCreateOrUpdate={setCreateOrUpdate}
                    loanDatabaseList={loanDatabaseList}
                    receivableDatabaseList={receivableDatabaseList}
                    priFillDataInModel={priFillDataInModel}
                    setEditLabel={setEditLabel}
                />

                {createModel &&(
                <React.Fragment>
                    <DataBaseCRUDModel
                        activeTab={activeTab}
                        updateOrCreateFlow={updateOrCreateFlow} 
                        dataBaseType={dataBaseType}
                        fromDate={fromDate} 
                        setfromDate={setfromDate}
                        todate = {todate}
                        settodate={settodate}
                        setcreateModel={setcreateModel}
                        companyDataList={companyDataList}
                        handleSelect={handleSelect}
                        handleRemove={handleRemove}
                        userSelectedDataList={userSelectedDataList}
                        sendDataToApi={sendDataToApi}
                        asOnDate={asOnDate}
                        setasOnDate={setasOnDate}
                        editLabel={editLabel}
                    />
                </React.Fragment>
            )}
                
            </div>
        </div>
    );
};

export default DataBase;


const DataBaseHeader = ({
    companyID,
    tab,
    settab,
    setcreateModel,
    openModel,
    companyName,
    setEditLabel={}
}) => {
    
    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: companyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Database",
            link: `/myfinV2/database/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
    ];
    return(
            <div className={baseCss.headerBar}>
                <div style={{display:'flex', alignItems:'baseline'}}>
                    <div className={baseCss.breadCrumbWrapper} style={{ marginRight:'5%' }}>
                        <Breadcrumb
                            addCls="bgTransprent"
                            items={breadcrumbItems}
                            headerActions={<></>}
                            p0={true}
                        />
                    </div>
                    <div className={baseCss.headerTabsContainer}>
                        <div 
                            className={`${baseCss.headerTabLeft} ${tab === 1 ? baseCss.tabActive : baseCss.tabInactive}`}
                            onClick={() => settab(1)} 
                            >
                            View by Data
                        </div>
                        <div
                            className={`${baseCss.headerTabRight} ${tab === 2 ? baseCss.tabActive : baseCss.tabInactive}`}
                            onClick={() => settab(2)} 
                            >
                            View by Register
                        </div>
                    </div>
                </div>
                <div>
                    <button style={{ paddingRight: '2px' }} type="button" className={baseCss.headerBaseCreateBtn} onClick={() => {setEditLabel(false);openModel()}}><WhitePlusIcon style={{ scale:'1', paddingBottom:'3px' }} /><span>Create New</span></button>
                </div>
            </div>
            )
}


const MulitTabsContainer = ({
    tab,
    settab, 
    createOrUpdate,
    setCreateOrUpdate,
    loanDatabaseList,
    priFillDataInModel,
    activeTab, 
    setActiveTab,
    receivableDatabaseList,
    setEditLabel={}
}) => {
    const [createTab, setCreateTab] = useState("I")
    

    return(
        <div style={{ display : 'flex' }}>
            
            <div className={ createTab == 'A' ? baseCss.tabContainerSideContainer :baseCss.tabContainer}> 
                
            {tab === 1 && 
                <div className={baseCss.tabContantContainer}> 
                  
                    <div className={baseCss.container}>

                        <div className={baseCss.cardCateContainer} onClick={() => {setCreateTab('A'); setCreateOrUpdate('C'); }} >
                            <div>
                                <AccLoansIcon className={baseCss.leftCardIcon}/>
                            </div>
                            <div className={baseCss.rightCardContainer}>
                                <div className={baseCss.cardTitleTxt}>Loans</div>
                                <div className={baseCss.cardTxt}> EIR <span className={baseCss.txtSep}>|</span> IRAC <span className={baseCss.txtSep}>|</span> ECL </div>
                            </div>
                        </div>

                        <div className={baseCss.cardCateContainer} onClick={() => {}}>
                            <div>
                                <AccLoansIcon className={baseCss.leftCardIcon}/>
                            </div>
                            <div className={baseCss.rightCardContainer}>
                                <div className={baseCss.cardTitleTxt}>Receviables</div>
                                <div className={baseCss.cardTxt}> ECL </div>
                            </div>
                        </div>

                        <div className={baseCss.cardCateContainer} onClick={() => {}}>
                            <div>
                                <AccLoansIcon className={baseCss.leftCardIcon}/>
                            </div>
                            <div className={baseCss.rightCardContainer}>
                                <div className={baseCss.cardTitleTxt}>Payables</div>
                                <div className={baseCss.cardTxt}> ECL </div>
                            </div>
                        </div>

                        <div className={baseCss.cardCateContainer} onClick={() => {}}>
                            <div>
                                <AccLoansIcon className={baseCss.leftCardIcon}/>
                            </div>
                            <div className={baseCss.rightCardContainer}>
                                <div className={baseCss.cardTitleTxt}>Sales</div>
                                <div className={baseCss.cardTxt}> ECL </div>
                            </div>
                        </div>

                        <div className={baseCss.cardCateContainer} onClick={() => {}}>
                            <div>
                                <AccLoansIcon className={baseCss.leftCardIcon}/>
                            </div>
                            <div className={baseCss.rightCardContainer}>
                                <div className={baseCss.cardTitleTxt}>Purchases</div>
                                <div className={baseCss.cardTxt}> ECL </div>
                            </div>
                        </div>

                    </div>

                </div>
            }

            {tab === 2 && 
                <div className={baseCss.tabContantContainer}>

                    <div className={baseCss.tabsContainer}>
                        <div onClick={ () => {setActiveTab('loan');} } className={`${baseCss.btn} ${ activeTab === 'loan' ? baseCss.btnActiveFirst : '' }`}>Loans</div>
                        <div onClick={ () => {setActiveTab('receivable');} } className={`${baseCss.btn} ${ activeTab === 'receivable' ? baseCss.btnActiveSecond : '' }`} >Receivables</div>
                    </div>

                    {activeTab === 'loan' && 

                        <div className={baseCss.tabMainContainer}>
                            <div className={baseCss.tabInsideWrapper}>
                            
                                <div className={baseCss.filterContainer}>
                                    <div className={baseCss.calenderContainer}>
                                        <div className={baseCss.leftCalenderContainer}>
                                            <div className={baseCss.calenderLabels}>
                                                From
                                            </div>
                                            <div className={baseCss.calenderDate}>
                                                01-01-2024
                                            </div>
                                            <div className={baseCss.calenderIconContainer}>
                                                <CalenderIcon />
                                            </div>
                                        </div>

                                        <div className={baseCss.RightCalenderContainer}>
                                            <div className={baseCss.calenderLabels}>
                                                To 
                                            </div>
                                            <div className={baseCss.calenderDate}>
                                                01-01-2024
                                            </div>
                                            <div className={baseCss.calenderIconContainer}>
                                                <CalenderIcon />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {loanDatabaseList.map((entry, index) => {
                                    const displayRegisters = entry.registers.slice(0, 4);
                                    const remainingCount = entry.registers.length - 4;

                                    return (
                                        <div key={entry._id} className={baseCss.tilesAndDateContainer}>
                                            <div className={baseCss.dates}>
                                                <div className={baseCss.dateContainerWrap}>
                                                    <div className={baseCss.fromAndToLabel}>From</div>
                                                    <div>
                                                        {new Date(entry.fromDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).toUpperCase()}
                                                    </div>
                                                </div>
                                                <div className={baseCss.dateContainerWrap}>
                                                    <div className={baseCss.fromAndToLabel}>To </div>
                                                    <div>
                                                        {new Date(entry.toDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).toUpperCase()}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={baseCss.seprator}></div>

                                            <div
                                                className={baseCss.tileSubContainer}
                                            >
                                                <div className={baseCss.tilesSubWarpper}>
                                                    {displayRegisters.map((reg, i) => (
                                                        <div key={reg._id} className={baseCss.tiles}>
                                                            {reg.name}
                                                        </div>
                                                    ))}
                                                </div>

                                                <div
                                                    onClick={() => {setEditLabel(true);priFillDataInModel('loan',entry._id)}} // data base id
                                                    className={baseCss.tilecustModelHeaderEditicon}
                                                > 
                                                    {remainingCount > 0 && (
                                                        <span>+{remainingCount}</span>
                                                    )}
                                                    <EditIcon className={baseCss.calIcon} />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>    
                        </div>
                        
                    }
                    
                    {activeTab === 'receivable' && 

                        <div className={baseCss.tabMainContainer}>
                            <div className={baseCss.tabInsideWrapper}>
                            
                                <div className={baseCss.filterContainer}>
                                    <div className={baseCss.calenderContainer}>
                                        <div className={baseCss.leftCalenderContainer}>
                                            <div className={baseCss.calenderLabels}>
                                                From
                                            </div>
                                            <div className={baseCss.calenderDate}>
                                                01-01-2024
                                            </div>
                                            <div className={baseCss.calenderIconContainer}>
                                                <CalenderIcon />
                                            </div>
                                        </div>

                                        <div className={baseCss.RightCalenderContainer}>
                                            <div className={baseCss.calenderLabels}>
                                                To 
                                            </div>
                                            <div className={baseCss.calenderDate}>
                                                01-01-2024
                                            </div>
                                            <div className={baseCss.calenderIconContainer}>
                                                <CalenderIcon />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {receivableDatabaseList.map((entry, index) => {
                                    const displayRegisters = entry.registers.slice(0, 4);
                                    const remainingCount = entry.registers.length - 4;

                                    return (
                                        <div key={entry._id} className={baseCss.tilesAndDateContainer}>
                                            <div className={baseCss.dates}>
                                                <div className={baseCss.dateContainerWrap}>
                                                    {/* <div>As on Date</div> */}
                                                    <div>
                                                        {new Date(entry.asOnDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).toUpperCase()}
                                                    </div>
                                                </div>
                                                {/* <div className={baseCss.dateContainerWrap}>
                                                    <div>To </div>
                                                    <div>
                                                        {new Date(entry.toDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }).toUpperCase()}
                                                    </div>
                                                </div> */}
                                            </div>

                                            <div className={baseCss.seprator}></div>

                                            <div
                                                className={baseCss.tileSubContainer}
                                            >
                                                <div className={baseCss.tilesSubWarpper}>
                                                    {displayRegisters.map((reg, i) => (
                                                        <div key={reg._id} className={baseCss.tiles}>
                                                            {reg.name}
                                                        </div>
                                                    ))}
                                                </div>

                                                <div
                                                    onClick={() => {setEditLabel(true);priFillDataInModel('receivable',entry._id)}} // data base id
                                                    className={baseCss.tilecustModelHeaderEditicon}
                                                > 
                                                    {remainingCount > 0 && (
                                                        <span>+{remainingCount}</span>
                                                    )}
                                                    <EditIcon className={baseCss.calIcon} />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>    
                        </div>

                    }
                    
                </div>
            }

            </div>
        </div>
        )
}



const DataBaseCRUDModel = ({
    activeTab,
    updateOrCreateFlow,
    setcreateModel,
    fromDate, 
    setfromDate,
    todate, 
    settodate,
    companyDataList,
    handleSelect,
    handleRemove,
    userSelectedDataList,
    sendDataToApi,
    dataBaseType,
    asOnDate,
    setasOnDate,
    editLabel
}) => {
     const [displayModal, setDisplayModal] = useState(false);
     const handleClose = () => {
     setDisplayModal(false);
    
     };
    return (
        <div
            className={`${baseCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={baseCss.cutmModelMainContainerSecond}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={baseCss.custModelHeader}>
                    {/* <div className={baseCss.custModelHeaderLabel}>Create {activeTab === 'loan' ? 'Loans' : activeTab === 'receivable' ? 'Receivable' : null}</div> */}
                    <div className={baseCss.custModelHeaderLabel}>{editLabel?"Edit":"Create"} {activeTab === 'loan' ? 'Register' : activeTab === 'receivable' ? 'Register' : null}</div>
                    <div className={baseCss.custmCursor}>
                        <CustModeLCloseIcon
                            className={`${baseCss.custModelHeaderCloseicon} ${baseCss.cursiorPointer}`}
                            onClick={() => {setcreateModel(false);}}
                        />
                    </div>
                </div>

                <div className={baseCss.p20}>
                    <div className={baseCss.custmLabel}>
                        Selected Register Type
                    </div>
                    <div className={baseCss.selectedModule}>
                        {dataBaseType}
                    </div>
                </div>

                {
                    activeTab === 'loan'
                    ?
                        <div className={baseCss.wrapperDateContainer}>
                            <div className={`${baseCss.p20} ${baseCss.pt0} ${baseCss.w50p}`} style={{ paddingRight:'10px' }}>
                                <div className={baseCss.custmLabel}>
                                    From date
                                </div>
                                <div className={baseCss.selecteDatedModule}>
                                    <DatePicker style={dateInputStyle}  dateFormat="dd MMM yyyy" className={baseCss.Custdatepicker} selected={fromDate} onChange={(date) => setfromDate(date)} /> 
                                    <div className={baseCss.calContaner}>
                                        <CalenderIcon className={baseCss.calIcon} />
                                    </div>
                                </div>
                            </div>

                            <div className={`${baseCss.p20} ${baseCss.pt0} ${baseCss.w50p}`} style={{ paddingLeft:'10px'}}>
                                <div className={baseCss.custmLabel}>
                                    To date
                                </div>
                                <div className={baseCss.selecteDatedModule}>
                                    <DatePicker className={baseCss.Custdatepicker} dateFormat="dd MMM yyyy" selected={todate} onChange={(date) => settodate(date)} />
                                    <div className={baseCss.calContaner}>
                                        <CalenderIcon className={baseCss.calIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    :

                    activeTab === 'receivable'
                    ?

                        <div className={baseCss.wrapperDateContainer}>
                            <div className={`${baseCss.p20} ${baseCss.pt0} ${baseCss.w100p}`}>
                                <div className={baseCss.custmLabel}>
                                    As on Date
                                </div>
                                <div className={baseCss.selecteDatedModule}>
                                    <DatePicker 
                                        style={dateInputStyle}  
                                        dateFormat="dd MMM yyyy" 
                                        className={baseCss.Custdatepicker} 
                                        selected={asOnDate} 
                                        onChange={(date) => setasOnDate(date)} 
                                    /> 
                                    <div className={baseCss.calContaner}>
                                        <CalenderIcon className={baseCss.calIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    :
                    null
                
                }

                <div className={`${baseCss.p20} ${baseCss.pt0}`}>
                    <div className={baseCss.custmLabel}>
                        Tag Registers
                    </div>
                    <Select
                        components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                        options={companyDataList}
                        placeholder="Register name"
                        name="status"
                        className="w-100 mt-0 custom-bg-gray-300"
                        onChange={handleSelect}
                        classNamePrefix="select"
                        styles={customStylesWithNewHeight}
                        isClearable={false}
                        isSearchable={false}
                    />
                </div>

                <div className={`${baseCss.cutModelBodyContainer} pt-0`}>

                    {userSelectedDataList.map((loan, index) => (
                        <div key={index} className={baseCss.selectRowContainer}> 
                            <div className={baseCss.selectTiles}>
                            <div className={baseCss.tileHeader}>
                                <div className={baseCss.tileheading}>{loan.label}</div>
                                <div>
                                <CustModeLCloseIcon
                                    className={`${baseCss.tilecustModelHeaderCloseicon} ${baseCss.cursiorPointer}`}
                                    onClick={() => handleRemove(loan)}
                                />
                                </div>
                            </div>
                            <div className={baseCss.userName}>
                                Adriene vasier
                            </div>
                            </div>
                        </div>
                    ))}
                
                </div>

                <div className={baseCss.cutModelFooterContainer}>

                    <div>
                        <button
                            type="button"
                            onClick={() => {setcreateModel(false);}}
                            className={baseCss.custModelFooterBtnSecondary}
                        >
                            Cancel
                        </button>

                        {/* { updateOrCreateFlow === 'update' 
                            ? 
                                <button
                                    type="button"
                                    onClick={() => {
                                    
                                        if (activeTab === 'loan') {
                                            if (updateOrCreateFlow === 'update') {
                                                sendDataToApi('loan', 'delete')
                                            } 
                                        } 
                                        else if (activeTab === 'receivable') {
                                            
                                            sendDataToApi('receivable', 'delete')
                                        } 

                                    }}
                                    className={baseCss.custModelFooterBtnDanger}
                                >
                                    Delete
                                </button>
                            :
                                ''
                        } */}


                    </div>
                    <div className={baseCss.updateDeleteContainer}>
                         { updateOrCreateFlow === 'update' 
                            ? 
                                <button
                                    type="button"
                                    onClick={() => {
                                    
                                        // if (activeTab === 'loan') {
                                        //     if (updateOrCreateFlow === 'update') {
                                        //         sendDataToApi('loan', 'delete')
                                        //     } 
                                        // } 
                                        // else if (activeTab === 'receivable') {
                                            
                                        //     sendDataToApi('receivable', 'delete')
                                        // } 
                                        setDisplayModal(true);

                                    }}
                                    className={baseCss.custModelFooterBtnDanger}
                                >
                                    Delete
                                </button>
                            :
                                ''
                        }
                    <button
                        type="button"
                        onClick={() => {

                            if (activeTab === 'loan') {
                                    if (updateOrCreateFlow === 'update') {
                                        sendDataToApi('loan', 'update');
                                    } 
                                    else {
                                        sendDataToApi('loan', 'create');
                                    }
                                } 
                                else if (activeTab === 'receivable') {
                                    
                                    if (updateOrCreateFlow === 'update') {
                                        sendDataToApi('receivable', 'update');
                                    } 
                                    else {
                                        sendDataToApi('receivable', 'create');
                                    }
                                } 
                            else {
                                // optional fallback
                                console.warn('Invalid tab');
                            }
                            
                        }
                        }
                        className={baseCss.custModelFooterBtnPrimary}
                    >
                        
                        {updateOrCreateFlow === 'update' ? 'Update Database' : 'Save Register to Database'}
                    </button>
                  </div>  
                </div>
            </div>
            {displayModal && (
                             <Modal
                              headerActions={
                                <CloseIcon
                                  onClick={() => {
                                    handleClose();
                                    setDisplayModal(false);
                                  }}
                                  className="clickable"
                                />
                              }
                              headerBottomLine={false}
                              onClose={() => console.log("Modal Closed")}
                            >
                              <span className={`${modalcss.modalDeleteBodyHead}  mb-1`}>
                                {/* Do you want to <span className="fw700">delete</span> the
                                company? */}
                                Are you sure you want to Delete?
                              </span>
                              
                              <span
                                className={`${modalcss.modalDeleteBodycnt}`}
                                style={{ "margin-bottom": "35px ","marginTop": "10px","padding":"0px 45px" }}
                              > 
                                {/* Once deleted, you cannot restore the company */}
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.Nam enim  posuere. Aliquam.
                              </span>
            
                              <span
                                className={`${modalcss.modalDeleteBodycnt} ${modalcss.modalDeleteBodyBtns}`}
                              >
                                <Button
                                  btnColor={buttoncss.dangerDeleteModelBtn}
                                  label="Yes, Delete"
                                //   icon={<DeleteIcon width={20} height={20} />}
                                  onClick={() => {
                                    // deleteCompany();
                                    // sendDataToIRACApi('D'); 
                                     if (activeTab === 'loan') {
                                            if (updateOrCreateFlow === 'update') {
                                                sendDataToApi('loan', 'delete')
                                            } 
                                        } 
                                        else if (activeTab === 'receivable') {
                                            
                                            sendDataToApi('receivable', 'delete')
                                        } 
                                    handleClose();
                                  }}
                                />
                                <Button
                                  btnColor={buttoncss.deleteModelBtn_secondary_del}
                                  label="No, Don't"
                                  onClick={() => {
                                    handleClose();
                                    setDisplayModal(false);
                                  }}
                                />
                              </span>
                            </Modal>
            )}

        </div>
  );
};


const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <PrimaryPlusIcon />
    </components.DropdownIndicator>
  );
};



const dateInputStyle = {
  backgroundColor: '#f4faf5',
  borderColor: '#c2e6d1',
  color: '#4d6d64',
  fontSize: '14px !important',
  fontWeight: 500,
  borderWidth: '1px',
  borderRadius: '10px',
  padding: '10px !important',
  minHeight: '38px',
  height: '38px',
  width: '100%',
  borderStyle: 'solid',
};



// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '0.5rem',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '0.5rem',
//     zIndex: 10,
//   }),
//    menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//     maxHeight: '200px !important',
//     overflowY: 'auto',
//     }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px"
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };



export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),

option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};


const customStylesWithNewHeight = {
  ...customStyles, 
  control: (provided, state) => ({
   
    ...customStyles.control(provided, state), 
    
    
    
    height: '44px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
     transform: 'scale(1.5)',
    ':hover': {
        color: '#205a46',
    },
    }),
 
};